import { request } from './client';
import {
  StudentPublic,
  CreateStudentPayload,
  UpdateStudentPayload,
  ListStudentsParams,
} from './types';

export function listStudents(
  params?: ListStudentsParams
): Promise<StudentPublic[]> {
  const query = new URLSearchParams();
  if (params?.ClassRoomId) query.set('ClassRoomId', params.ClassRoomId);
  if (params?.date) query.set('date', params.date);
  const qs = query.toString();
  return request<StudentPublic[]>(`/students${qs ? `?${qs}` : ''}`);
}

export function getStudent(id: string): Promise<StudentPublic> {
  return request<StudentPublic>(`/students/${id}`);
}

export function createStudent(
  payload: CreateStudentPayload
): Promise<StudentPublic> {
  const { classRoomId, ...rest } = payload;
  return request<StudentPublic>('/students', {
    method: 'POST',
    body: JSON.stringify({ ...rest, ClassRoomId: Number(classRoomId) }),
  });
}

export function updateStudent(
  payload: UpdateStudentPayload
): Promise<StudentPublic> {
  const { id, ...body } = payload;
  return request<StudentPublic>(`/students/${id}`, {
    method: 'PUT',
    body: JSON.stringify(body),
  });
}

export function deleteStudent(payload: {
  id: string;
}): Promise<StudentPublic> {
  return request<StudentPublic>(`/students/${payload.id}`, {
    method: 'DELETE',
  });
}
